import { controlServiceImpl } from "@lvt/streaming";
import {
    WebData,
    webDataError,
    webDataErrorSimple,
    webDataLoading,
    webDataNotAsked,
    webDataSuccess,
} from "@lvt/web-data";
import { Fab, Grid, Tooltip } from "@material-ui/core";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import clsx from "clsx";
import { useState } from "react";

import client from "@/api/client";
import useActionButtonStyles from "@/common/components/streaming/ActionButtons/ActionButton.styles";
import { RootState, useDispatch, useSelector } from "@/store";
import { addAlert, Severity } from "@/store/alerts/slice";
import * as FullStory from "@/utilities/hooks/fullstory";

import SnapshotModal from "./SnapshotModal/SnapshotModal";


const SnapshotButton: React.FC = () => {
    const actionButtonClasses = useActionButtonStyles();
    const [snapshotImage, setSnapshotImage] = useState<WebData<string>>(webDataNotAsked());
    const [snapshotModalIsOpen, setSnapshotModalIsOpen] = useState<boolean>(false);

    const streamingId = useSelector((state: RootState) => state.cameras.streamingId);
    const dispatch = useDispatch();

    const controlService = controlServiceImpl(client, streamingId!); // streamingId should never be null;

    const handleSnapshot = async () => {
        setSnapshotModalIsOpen(true);
        setSnapshotImage(webDataLoading());

        try {
            const res = await controlService.takeSnapshot();

            if (res.data) {
                setSnapshotImage(webDataSuccess(JSON.parse(res.data).image));
            } else {
                setSnapshotModalIsOpen(false);
                setSnapshotImage(webDataError({ status: res.code, body: "", message: "" }));
                dispatch(
                    addAlert({
                        severity: Severity.Error,
                        message: `Failed to take snapshot: command proxy error code ${res.code}`,
                    }),
                );
            }
        } catch (e) {
            setSnapshotModalIsOpen(false);
            setSnapshotImage(webDataErrorSimple({ message: JSON.stringify(e) }));
            dispatch(
                addAlert({
                    severity: Severity.Error,
                    message: `Failed to take snapshot: ${e}`,
                }),
            );
        }
    };

    return (
        <Grid item className={clsx(FullStory.names.classes.streaming.snapshot, actionButtonClasses.fabItem)}>
            {streamingId ? (
                <>
                    <Tooltip PopperProps={{ disablePortal: true }} title="Snapshot" placement="top">
                        <Fab
                            id={"streaming_snapshot-button"}
                            className={actionButtonClasses.fab}
                            color="primary"
                            onClick={handleSnapshot}
                        >
                            <PhotoCameraIcon />
                        </Fab>
                    </Tooltip>
                    <SnapshotModal
                        image={snapshotImage}
                        handleVisible={setSnapshotModalIsOpen}
                        visible={snapshotModalIsOpen}
                    />
                </>
            ) : (
                <Fab
                    className={actionButtonClasses.fab}
                    disabled
                >
                    <PhotoCameraIcon />
                </Fab>
            )}
        </Grid>
    );
};

export default SnapshotButton;
